angular.module('forms').controller('CompleteFormCtrl',
    ['$scope', '$stateParams', 'toaster', 'aprgettext', 'LocalStorageRepository', 'FormsRepository', 'FormsService', 'TransitionManager',
        function ($scope, $stateParams, toaster, gettext, LocalStorageRepository, FormsRepository, FormsService, TransitionManager) {
            'use strict';

            $scope.loading = true;

            $scope.questionnaire = {
                relSurveyPatientId: null,
                patientId: null,
                questionnaireId: null,
                questionnaireName: '',
                questionnaireDetails: null
            };

            // Unique SurveySectionUid + SurveyQuestionUid + SurveyAnswerUid
            $scope.questionnaireSections = {
                sections: null,
                currentSectionNumber: 0,
                currentSectionId: null,
                currentSectionName: '',
                nextSectionName: '',
                firstSectionNumber: 0,
                lastSectionNumber: 0,
                maxNavigationItems: 5
            };


            if ($stateParams.relSurveyPatientId) {
                $scope.questionnaire.relSurveyPatientId = $stateParams.relSurveyPatientId;
            }
            if ($stateParams.patientId) {
                $scope.questionnaire.patientId = $stateParams.patientId;
            }
            if ($stateParams.questionnaireId) {
                $scope.questionnaire.questionnaireId = $stateParams.questionnaireId;
            }

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();

                FormsRepository
                    .getQuestionnaireDetails(LocalStorageRepository.getUserID(), $scope.questionnaire.relSurveyPatientId)
                    .then(function (data) {
                        $scope.questionnaire.questionnaireDetails = data;
                        $scope.questionnaire.questionnaireName = data[0].SurveyName;

                        var sectionNumber = 0;
                        $scope.questionnaireSections.sections = _($scope.questionnaire.questionnaireDetails)
                            .sortBy('SectionDisplayOrder', 'QuestionDisplayOrder', 'SurveyAnswerGroupSurveyAnswerDisplayOrder')
                            .groupBy('SurveySectionId')
                            .map(function (surveySectionQuestions) {
                                var surveySection = surveySectionQuestions[0];
                                return {
                                    SurveySectionId: surveySection.SurveySectionId,
                                    SectionNumber: ++sectionNumber,
                                    SurveySectionName: surveySection.SurveySectionName,
                                    DisplayOrder: surveySection.SectionDisplayOrder,
                                    Visible: (sectionNumber <= $scope.questionnaireSections.maxNavigationItems) ? true : false,
                                    Questions: createQuestionList(surveySectionQuestions)
                                };
                            })
                            .value();


                        if ($scope.questionnaireSections.sections && $scope.questionnaireSections.sections.length) {
                            $scope.questionnaireSections.currentSectionNumber = 1;
                            $scope.questionnaireSections.currentSectionId = $scope.questionnaireSections.sections[0].SurveySectionId;
                            $scope.questionnaireSections.currentSectionName = $scope.questionnaireSections.sections[0].SurveySectionName;
                            $scope.questionnaireSections.firstSectionNumber = 1;

                            $scope.questionnaireSections.lastSectionNumber =
                                $scope.questionnaireSections.sections.length > $scope.questionnaireSections.maxNavigationItems ? $scope.questionnaireSections.maxNavigationItems
                                    : $scope.questionnaireSections.sections.length;

                            $scope.questionnaireSections.nextSectionName = getNextSectionName();
                        }
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {


                        FormsRepository
                            .getPatientQuestionnaire(LocalStorageRepository.getUserID(), $scope.questionnaire.relSurveyPatientId)
                            .then(function (data) {
                                $scope.patientQuestionnaire = data;
                            })
                            .finally(function() {
                                console.log($scope.questionnaireSections);
                                console.log($scope.patientQuestionnaire);
                                console.log('pause');
                            });


                        $scope.loading = false;
                    });
            }
            loadPage();


            function createQuestionList(sectionQuestions) {
                var questionNumber = 0;

                var questions = _(sectionQuestions)
                    .groupBy('SurveyQuestionId')
                    .map(function (sectionQuestionAnswers) {
                        var sectionQuestionAnswer = sectionQuestionAnswers[0];

                        var question = {
                            QuestionNumber: ++questionNumber,
                            SurveySectionId: sectionQuestionAnswer.SurveySectionId,
                            SurveyQuestionId: sectionQuestionAnswer.SurveyQuestionId,
                            SurveyQuestionLabel: sectionQuestionAnswer.SurveyQuestionLabel,
                            SectionOptional: sectionQuestionAnswer.SectionOptional,
                            QuestionOptional: sectionQuestionAnswer.QuestionOptional,
                            SurveyControlTypeId: sectionQuestionAnswer.SurveyControlTypeId,
                            SurveyControlTypeName: sectionQuestionAnswer.SurveyControlTypeName,
                            SelectedAnswerId: getSelectedAnswerId(sectionQuestionAnswer.SurveySectionId, sectionQuestionAnswer.SurveyQuestionId, sectionQuestionAnswer.SurveyControlTypeId),
                            QuestionEnabled: isQuestionEnabled(sectionQuestionAnswer),
                            Answers: createAnswerList(sectionQuestionAnswers),
                            AnswersThatTriggerThisQuestion: getAnswersThatTriggerThisQuestion(sectionQuestionAnswer)
                        };

                        question.HasAnswersThatTriggerThisQuestion = false;
                        if (question.AnswersThatTriggerThisQuestion !== null) {
                            if (question.AnswersThatTriggerThisQuestion.length > 0) {
                                if (question.AnswersThatTriggerThisQuestion[0] !== '00000000-0000-0000-0000-000000000000') {
                                    question.HasAnswersThatTriggerThisQuestion = true;
                                }
                            }
                        }

                        return question;
                    })
                    .value();

                return questions;
            }


            function getAnswersThatTriggerThisQuestion(question) {
                /*
                    select SurveySectionUid, SurveyQuestionUid, SurveyAnswerUid
                    from details
                    where TriggeringSurveyQuestionUid
                    SurveySectionUid
                */
                var answers = _($scope.questionnaire.questionnaireDetails)
                    .filter({
                        SurveySectionId: question.SurveySectionId,
                        QuestionIdToTrigger: question.SurveyQuestionId
                    })
                    .map(function (answer) {
                        return {
                            SurveySectionId: answer.SurveySectionId,
                            SurveyQuestionId: answer.SurveyQuestionId,
                            SurveyAnswerId: answer.SurveyAnswerId
                        };
                    })
                    .value();

                return answers;
            }


            function isQuestionEnabled(question) {
                if (!question.QuestionOptional) {
                    // QuestionOptional means the question is dependent on another questions answer to be selected in order to be enabled.
                    return true;
                }

                var answer = _($scope.questionnaire.questionnaireDetails)
                    .filter({
                        SurveySectionId: question.SurveySectionId,
                        QuestionIdToTrigger: question.SurveyQuestionId,
                        SelectedAnswer : true
                    }).head();

                return answer === undefined ? false : answer.SelectedAnswer;
            }


            function getSelectedAnswerId(surveySectionId, surveyQuestionId, surveyControlTypeId) {
                var selectedAnswer = null;

                if (surveyControlTypeId && surveyControlTypeId.toUpperCase() === 'EC316E58-2265-4C2A-8E93-EA1D15143B0D') {
                    // radio button
                    selectedAnswer = _($scope.questionnaire.questionnaireDetails)
                        .filter({
                            SurveySectionId: surveySectionId,
                            SurveyQuestionId: surveyQuestionId,
                            SelectedAnswer : true
                        }).head();
                }

                return selectedAnswer && selectedAnswer.SurveyAnswerId;
            }


            function createAnswerList(sectionQuestionAnswers) {
                var myAnswers = _(sectionQuestionAnswers)
                    .groupBy('SurveyAnswerId')
                    .map(function (answers) {
                        var answer = answers[0];
                        return {
                            SurveySectionId: answer.SurveySectionId,
                            SurveyQuestionId: answer.SurveyQuestionId,
                            QuestionOptional: answer.QuestionOptional,
                            SurveyAnswerId: answer.SurveyAnswerId,
                            SurveyControlTypeId: answer.SurveyControlTypeId,
                            SurveyAnswerLabel: answer.SurveyAnswerLabel,
                            SelectedAnswer: answer.SelectedAnswer,
                            SurveyResponseAnswerText: answer.SurveyResponseAnswerText,
                            QuestionsToTrigger: _(answers).map(function (answer) {
                                    return { QuestionId: answer.QuestionIdToTrigger };
                                }
                            ).value()
                        };
                    })
                    .value();

                return myAnswers;
            }


            function submitQuestionnaire() {
                //var questionnaire = $scope.questionnaire.questionnaireDetails;
                // TODO - call forms repository to complete form
                var completedForm = {
                    Form: { Id: $scope.questionnaire.relSurveyPatientId, Name: $scope.questionnaire.questionnaireName},
                    Patient: { Id: $scope.questionnaire.patientId}
                };
                FormsService.cacheCompletedForm(completedForm);
                TransitionManager.transition({appRoute: 'confirmForm'});
            }


            function getCurrentSectionName() {
                // Sections collection is zero based.  Section Number is 1 based.
                if ($scope.questionnaireSections.currentSectionNumber > 0) {
                    return $scope.questionnaireSections.sections[$scope.questionnaireSections.currentSectionNumber - 1].SurveySectionName;
                }
            }


            function getNextSectionName() {
                // Sections collection is zero based.  Section Number is 1 based.
                if ($scope.questionnaireSections.currentSectionNumber < $scope.questionnaireSections.sections.length) {
                    return $scope.questionnaireSections.sections[$scope.questionnaireSections.currentSectionNumber].SurveySectionName;
                }
                else {
                    return 'Submit Form';
                }
            }


            $scope.navMoveNext = function navMoveNext() {
                $scope.completeQuestionnaireForm.isSubmitted = true;
                if (!$scope.completeQuestionnaireForm.$valid) {
                    return;
                }

                $scope.completeQuestionnaireForm.isSubmitted = false;
                if ($scope.questionnaireSections.currentSectionNumber === $scope.questionnaireSections.sections.length) {
                    return submitQuestionnaire();
                }

                var curSectionNumber = $scope.questionnaireSections.currentSectionNumber;
                var numOfSections = $scope.questionnaireSections.sections.length;

                if (curSectionNumber > 0 && curSectionNumber < numOfSections) {
                    $scope.questionnaireSections.currentSectionNumber = ++curSectionNumber;
                    $scope.questionnaireSections.currentSectionName = getCurrentSectionName();

                    if (curSectionNumber > $scope.questionnaireSections.lastSectionNumber)
                    {
                        $scope.questionnaireSections.firstSectionNumber++;
                        $scope.questionnaireSections.lastSectionNumber++;
                        _.forEach($scope.questionnaireSections.sections, function (section) {
                            if ((section.SectionNumber >= $scope.questionnaireSections.firstSectionNumber) &&
                                (section.SectionNumber <= $scope.questionnaireSections.lastSectionNumber))  {
                                section.Visible = true;
                            }
                            else {
                                section.Visible = false;
                            }
                        });
                    }

                    $scope.questionnaireSections.nextSectionName = getNextSectionName();
                }
            };


            $scope.navMovePrevious = function navMovePrevious() {
                $scope.completeQuestionnaireForm.isSubmitted = false;

                var curSectionNumber = $scope.questionnaireSections.currentSectionNumber;

                if (curSectionNumber > 1) {
                    $scope.questionnaireSections.currentSectionNumber = --curSectionNumber;
                    $scope.questionnaireSections.currentSectionName = getCurrentSectionName();

                    if (curSectionNumber < $scope.questionnaireSections.firstSectionNumber) {
                        $scope.questionnaireSections.firstSectionNumber--;
                        $scope.questionnaireSections.lastSectionNumber--;
                        _.forEach($scope.questionnaireSections.sections, function (section) {
                            if ((section.SectionNumber >= $scope.questionnaireSections.firstSectionNumber) &&
                                (section.SectionNumber <= $scope.questionnaireSections.lastSectionNumber))  {
                                section.Visible = true;
                            }
                            else {
                                section.Visible = false;
                            }
                        });
                    }

                    $scope.questionnaireSections.nextSectionName = getNextSectionName();
                }
            };


            $scope.displaySection = function displaySection(section) {
                if (section.SectionNumber === $scope.questionnaireSections.currentSectionNumber) {
                    // User is wanting to page to current section
                    $scope.completeQuestionnaireForm.isSubmitted = false;
                    return;
                }
                else if (section.SectionNumber < $scope.questionnaireSections.currentSectionNumber) {
                    // User is wanting to page to a previous section.  Don't have to fill out section is moving to a previous one,
                    $scope.completeQuestionnaireForm.isSubmitted = false;
                    $scope.questionnaireSections.currentSectionNumber = section.SectionNumber;
                    $scope.questionnaireSections.currentSectionName = getCurrentSectionName();
                    $scope.questionnaireSections.nextSectionName = getNextSectionName();
                    return;
                }

                // User is wanting to page to next section
                if (!$scope.completeQuestionnaireForm.$valid) {
                    // View is not valid.
                    $scope.completeQuestionnaireForm.isSubmitted = true;
                    return;
                }
                else {
                    // View is valid.
                    $scope.completeQuestionnaireForm.isSubmitted = false;
                    $scope.questionnaireSections.currentSectionNumber = section.SectionNumber;
                    $scope.questionnaireSections.currentSectionName = getCurrentSectionName();
                    $scope.questionnaireSections.nextSectionName = getNextSectionName();
                    return;
                }
            };

        }]);